(() => {
  const hoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  function openDetails(details, drawer) {
    if (!hoverPointer.matches || details.open) return;

    const summary = details.querySelector(':scope > summary');
    if (!summary) return;

    details.open = true;
    summary.setAttribute('aria-expanded', 'true');

    requestAnimationFrame(() => details.classList.add('menu-opening'));

    if (details.classList.contains('menu-drawer-container')) {
      document.body.classList.add(`overflow-hidden-${drawer.dataset.breakpoint}`);
      return;
    }

    const parentMenu = details.closest('.has-submenu');
    if (parentMenu) parentMenu.classList.add('submenu-open');
  }

  function bindHoverMenus(root = document) {
    root.querySelectorAll('header-drawer').forEach((drawer) => {
      if (drawer.dataset.hoverMenuBound === 'true') return;
      drawer.dataset.hoverMenuBound = 'true';

      const mainDetails = drawer.querySelector(':scope > details.menu-drawer-container');
      const mainSummary = mainDetails?.querySelector(':scope > summary');

      mainSummary?.addEventListener('mouseenter', () => openDetails(mainDetails, drawer));

      drawer.querySelectorAll('#menu-drawer details > summary').forEach((summary) => {
        summary.addEventListener('mouseenter', () => openDetails(summary.parentElement, drawer));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindHoverMenus());
  } else {
    bindHoverMenus();
  }

  document.addEventListener('shopify:section:load', (event) => bindHoverMenus(event.target));
})();
